




import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import { setCookie, getCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
@Component({
  components: {}
})
export default class extends Vue {
    
}
